import { render, staticRenderFns } from "./WrsAlert.vue?vue&type=template&id=c21b5f6c&"
import script from "./WrsAlert.vue?vue&type=script&lang=js&"
export * from "./WrsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports